import { render } from "./restore-form.vue?vue&type=template&id=3ab8c400&scoped=true"
import script from "./restore-form.vue?vue&type=script&setup=true&lang=js"
export * from "./restore-form.vue?vue&type=script&setup=true&lang=js"

import "./restore-form.vue?vue&type=style&index=0&id=3ab8c400&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab8c400"],['__file',"src/views/auth/restore-form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ab8c400"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ab8c400', __exports__)) {
    api.reload('3ab8c400', __exports__)
  }
  
  module.hot.accept("./restore-form.vue?vue&type=template&id=3ab8c400&scoped=true", () => {
    api.rerender('3ab8c400', render)
  })

}


export default __exports__